module.exports = __webpack_public_path__ + "static/media/message_chat.655d0911.svg";